import { useParams } from 'react-router-dom';
import { useSelector } from '@cbridge-utils/react-redux';
import { nodeNameByIdSelector, nodeIdByServerIdSelector } from '@cbridge-packages/node';

export const useCurrentNodeAndServer = () => {
  const { nodeId: nodeIdParam, serverId } = useParams<'nodeId' | 'serverId'>();

  const nodeIdByServerId = useSelector(nodeIdByServerIdSelector, { serverId });
  const nodeId = nodeIdParam && Number(nodeIdParam) || nodeIdByServerId;
  const nodeName = useSelector(nodeNameByIdSelector, { nodeId });

  return { nodeId, nodeName, serverId };
};
